import axios from "./configAxios";

export const getGroupListApi = async() => {
    return await axios.get('/list/')
}